export enum ApiNames{
  'ScanXtract'='ScanXtract',
  'CreateDocumentAccess' = 'CreateDocumentAccess',
  'ReadDocumentAccess' = 'ReadDocumentAccess'
}
